module.exports = __webpack_public_path__ + "img/Mobile App Developer.4fbdd3a2.png";